import { useState } from "react";
import { Badge, Box, Button, IconButton, Popover, Tooltip } from "@mui/material";
import FilterIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";

type FilterMenuProps = {
  children: React.ReactNode;
  activeFiltersCount: number;
  onReset: () => void;
  tooltip?: string;
};

const FilterMenu: React.FC<FilterMenuProps> = (props) => {
  const { children, activeFiltersCount, onReset, tooltip } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Badge color="primary" badgeContent={activeFiltersCount} invisible={!activeFiltersCount}>
            <FilterIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box p={3} maxWidth={360}>
          {children}

          {activeFiltersCount > 0 && (
            <Button
              fullWidth
              variant="outlined"
              color="error"
              onClick={() => {
                setAnchorEl(null);
                onReset();
              }}
              sx={{ mt: 3 }}
              startIcon={<ClearIcon />}
            >
              Rensa filter
            </Button>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default FilterMenu;
